import React from 'react';
import EmailPipelinePage from '../features/emailPipeline/pages/EmailPipelinePage';

const EmailPipeline: React.FC = () => <EmailPipelinePage />;

export default EmailPipeline;
